import { Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import ls from 'localstorage-slim';

import Layout from './Layouts/Layout';

import Invoice from './InvoiceComponents/Invoice';
import NewDocument from './InvoiceComponents/NewDocument';
import Document from './InvoiceComponents/Document';
import DraftDocument from './InvoiceComponents/DraftDocument';
import InvoiceDetails from './InvoiceComponents/InvoiceDetails';
import InvoicePackages from './InvoiceComponents/InvoicePackages';
import SubmittedInvoices from './InvoiceComponents/SubmittedInvoices';
import ReceivedInvoices from './InvoiceComponents/ReceivedInvoices';
import AllInvoices from './InvoiceComponents/AllInvoices';
import SearchPortalDocument from './InvoiceComponents/SearchPortalDocuments';
import SearchSobolDocument from './InvoiceComponents/SearchSobolDocuments';

import CodeDetails from './CodeComponents/CodeDetails';
import Code from './CodeComponents/Code';

import Receipt from './ReceiptComponents/Receipt';

import Stepper from './StepperComponents/Stepper';

import ContactPage from './GeneralComponents/ContactPage';
import Dashboard from './GeneralComponents/Dashboard';
import Home from './GeneralComponents/Home';
import LandingPage from './GeneralComponents/LandingPage';
import Login from './GeneralComponents/Login';
import ManualPage from './GeneralComponents/ManualPage';
import TaxPayer from './GeneralComponents/TaxPayer';
import Welcome from './GeneralComponents/Welcome';
import PostPay from './GeneralComponents/PostPay';

import Report from './ReportComponents/Report';

import DataContext from './context/InvoiceData';

import './App.css';

import { useIdleTimer } from 'react-idle-timer';
import { logout } from './helpers';

function App() {
  let token = ls.get('access');
  const [step, setStep] = useState(0);
  const [isAuthenticated, setIsAuthenticated] = useState(token);
  const [documentType, setDocumentType] = useState('');
  const [documentTypeVersion, setDocumentTypeVersion] = useState('');
  const [invoiceSubType, setInvoiceSubType] = useState('');
  const [remaining, setRemaining] = useState(+process.env.REACT_APP_Timeout);
  const [open, setOpen] = useState(false);

  const onIdle = async () => {
    if (!isAuthenticated) return;
    setOpen(false);
    await logout();
  };

  const onActive = () => {
    if (!isAuthenticated) return;
    setOpen(false);
  };

  const onPrompt = () => {
    if (!isAuthenticated) return;
    setOpen(true);
  };

  const handleStillHere = () => {
    activate();
  };

  const handleLogout = async () => {
    await logout();
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout: +process.env.REACT_APP_Timeout,
    promptBeforeIdle: +process.env.REACT_APP_Prompt,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  const timeTillPrompt = Math.max(remaining - +process.env.REACT_APP_Prompt / 1000, 0);
  const seconds = timeTillPrompt > 1 ? 'seconds' : 'second';

  return (
    <>
      <div
        className='modal p-5'
        style={{
          display: open ? 'flex' : 'none',
          backgroundColor: open ? '#cdd5d9' : '',
        }}
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        aria-hidden='true'
        tabIndex='-1'>
        <div className='modal-dialog modal-dialog-centered modal-md text-center'>
          <div className='modal-content'>
            <div className='modal-header'>
              <div className='row justify-content-start'>
                <img
                  src='/Sobol_logo.png'
                  alt='Sobol Logo'
                  className='m-auto col-1 d-inline-block'
                  style={{ height: '15%', width: '15%' }}
                />
                <span className='fs-3 fw-bold my-auto col d-inline-block text-start'>
                  Session Alert
                </span>
              </div>
            </div>
            <div className='modal-body'>
              <h3>Your are about to be logged out, do you want to stay?</h3>
              <p>
                Logging out in {remaining} {seconds}
              </p>
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-danger'
                data-bs-dismiss='modal'
                onClick={handleLogout}>
                Logout
              </button>
              <button type='button' className='btn btn-primary' onClick={handleStillHere}>
                I'm still here
              </button>
            </div>
          </div>
        </div>
      </div>

      <DataContext.Provider
        value={{
          step,
          setStep,
          isAuthenticated,
          setIsAuthenticated,
          documentType,
          setDocumentType,
          documentTypeVersion,
          setDocumentTypeVersion,
          invoiceSubType,
          setInvoiceSubType,
        }}>
        {isAuthenticated ? (
          <Routes>
            <Route path='taxpayer' element={<TaxPayer />} />
            <Route path='submitInvoiceSteps' element={<Stepper />} />
            <Route path='/' element={<Layout />}>
              <Route path='home' element={<Home />}>
                <Route path='welcome' element={<Welcome />} />
                <Route path='dashboard' element={<Dashboard />} />
              </Route>
              <Route path='documents' element={<Invoice />}>
                <Route path='submitted' element={<SubmittedInvoices />} />
                <Route path='received' element={<ReceivedInvoices />} />
                <Route path='all' element={<AllInvoices />} />
                <Route path='searchPortal' element={<SearchPortalDocument />} />
                <Route path='searchSobol' element={<SearchSobolDocument />} />
              </Route>
              <Route path='documents/:uuid' element={<InvoiceDetails />} />
              <Route path='documents/packages' element={<InvoicePackages />} />
              <Route path='document' element={<Document />}>
                <Route path='new' element={<NewDocument />} />
                <Route path='draft' element={<DraftDocument />} />
              </Route>

              <Route path='receipt' element={<Receipt />} />
              <Route path='codes' element={<Code />} />
              <Route path='codes/:itemCode/:codeType' element={<CodeDetails />} />
              <Route path='reports' element={<Report />} />
              <Route path='*' element={<Navigate to='/home/welcome' replace />} />
            </Route>
          </Routes>
        ) : (
          <Routes>
            <Route path='lp' element={<LandingPage />}></Route>

            <Route path='postPay' element={<PostPay />}></Route>

            <Route path='contact' element={<ContactPage />} />

            <Route path='manual' element={<ManualPage />} />

            <Route path='login' element={<Login />} />
            <Route path='*' element={<Navigate to='/lp' replace />}></Route>
          </Routes>
        )}
      </DataContext.Provider>
    </>
  );
}

export default App;
